import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { loginRequest } from '../../../authConfig';

type ErrorComponentProps = {
  error: { errorMessage: string | null };
};

/**
 * ErrorComponent displays an error message.
 *
 * @component
 * @param {ErrorComponentProps} props - The properties for the ErrorComponent.
 * @param {Object} ErrorComponentProps.error - The error object containing the error message.
 * @returns {JSX.Element} The rendered component with the error message.
 */
export default function ErrorComponent({
  error
}: ErrorComponentProps): JSX.Element {
  const { instance } = useMsal();
  const { t } = useTranslation('global');

  useEffect(() => {
    instance.loginRedirect(loginRequest).catch(() => {});
  }, [instance]);

  return (
    <Typography>{`${t('common.commonProperties.anError')}: ${
      error?.errorMessage
    }`}</Typography>
  );
}
